module.exports = __webpack_public_path__ + "img/hosoi.969e2ede.png";